import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    login: false,
    user: null,
    entity: null,
    missingSlsrpts: null,
    slsrptDate: null,
    insert: true,
    isOtherSellout: false,
    otherSellout: null,
    rowSelected: false,
    keycloakToken: null,
    fileFormatDisabled: true,
    sendDisabled: false
  },
  mutations: {
    login(state) {
      state.login = true;
    },
    logout(state) {
      state.login = false;
    },
    insert(state) {
      state.insert = true;
    },
    show(state) {
      state.insert = false;
    },
    showOtherSellout(state) {
      state.isOtherSellout = true;
    },
    hideOtherSellout(state) {
      state.isOtherSellout = false;
    },
    showRow(state) {
      state.rowSelected = true;
    },
    hideRow(state) {
      state.rowSelected = false;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setEntity(state, payload) {
      state.entity = payload;
    },
    setMissingSlsrpts(state, payload) {
      state.missingSlsrpts = payload;
    },
    setSlsrptDate(state, payload) {
      state.slsrptDate = payload;
    },
    setKeycloakToken(state, payload) {
      state.keycloakToken = payload;
    },
    setOtherSellout(state, payload) {
      state.otherSellout = payload;
    },
    enableFileFormat(state) {
      state.fileFormatDisabled = false;
    },
    disableFileFormat(state) {
      state.fileFormatDisabled = true;
    },
    enableSend(state) {
      state.sendDisabled = false;
    },
    disableSend(state) {
      state.sendDisabled = true;
    }
  },
  actions: {
    setUser(context, payload) {
      context.commit('setUser', payload);
    },
    setEntity(context, payload) {
      context.commit('setEntity', payload);
    },
    setMissingSlsrpts(context, payload) {
      context.commit('setMissingSlsrpts', payload);
    },
    setSlsrptDate(context, payload) {
      context.commit('setSlsrptDate', payload);
    },
    setKeycloakToken(context, payload) {
      context.commit('setKeycloakToken', payload);
    },
    setOtherSellout(context, payload) {
      context.commit('setOtherSellout', payload);
    }
  }
})

export default store